import React, { useState } from "react"
import { Routes, Route, BrowserRouter } from "react-router-dom"
import { Protected } from "./components/Protected"
import { Home } from "./views/Home"
import { Login, VRCallback } from "./views/Login"
import { OldURLVideoRedirect, Video } from "./views/Video"
import { UserRole } from "./services/auth/auth.types"
import { Limbo } from "./views/Limbo"
import { NotImplemented } from "./views/NotImplemented"
import { Direct, OldURLDirectRedirect } from "./views/Direct"
import { Directs } from "./views/Directs"
import { Videos, LikedVideos, MostLikedVideos, MostViewedVideos, History } from "./views/Videos"
import { AddVideo } from "./views/AddVideo"
import { PendingVideos } from "./views/PendingVideos"
import { EditVideo } from "./views/EditVideo"
import { AddDirect } from "./views/AddDirect"
import { EditDirect } from "./views/EditDirect"
import { LiveRedirect } from "./components/LiveRedirect"
import { Settings } from "./views/Settings"
import { Contact } from "./views/Contact"
import { FeaturedPlaylists, Playlists } from "./views/Playlists"
import { AddPlaylist } from "./views/AddPlaylist"
import { HeaderBar } from "./components/HeaderBar"
import { useAuthContext } from "./services/auth"
import { Footer } from "./components/Footer"
import { Box, useTheme } from "@mui/material"
import { Main, RetroHyrisButton } from "./components/StyledElements"
import { Playlist } from "./views/Playlist"
import { EditPlaylist } from "./views/EditPlaylist"
import { SideMenu } from "./components/SideMenu"
import { CONSTANTS } from "./components/Util"
import useWindowDimensions from "./services/useWindowDimensions"
import { ThemeMenu } from "./views/Theme"

export const Router = (): React.ReactElement => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/auth/callback" element={<VRCallback />} />
        <Route path="*" element={<FormattedRoutes />} />
      </Routes>
    </BrowserRouter>
  )
}

const FormattedRoutes = (): React.ReactElement => {
  const [searchFocused, setSearchFocused] = useState<boolean>(false)
  const [openSideMenu, setOpenSideMenu] = useState<boolean>(false)
  const { width } = useWindowDimensions()
  const theme = useTheme()
  const drawerMode = width >= 1200 ? "permanent" : "temporary"
  const { isAuth } = useAuthContext()
  return (
    <>
      <SideMenu open={openSideMenu} onClose={() => setOpenSideMenu(false)} drawerMode={drawerMode} />
      {theme.name === "classic" && width >= theme.breakpoints.values.sm && (
        <RetroHyrisButton onClick={() => setOpenSideMenu((b) => !b)} />
      )}
      <Box
        sx={{
          minHeight: "100vh",
          marginLeft: drawerMode === "permanent" && openSideMenu ? `${CONSTANTS.sideMenuWidth}px` : 0,
          transition: "margin-left 0.3s",
        }}
      >
        <HeaderBar
          noSearchBar={!isAuth()}
          setSearchFocus={setSearchFocused}
          toggleSideMenu={() => setOpenSideMenu(!openSideMenu)}
        />
        <Main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/portfolio" element={<NotImplemented />} />
            <Route path="/theme" element={<ThemeMenu />} />
            <Route path="/videos" element={<Videos />} />
            <Route path="/video" element={<Video searchFocused={searchFocused} />} />
            <Route path="/video/:videoId" element={<OldURLVideoRedirect />} />
            <Route
              path="/directs"
              element={
                <Protected>
                  <Directs />
                </Protected>
              }
            />
            <Route
              path="/direct"
              element={
                <Protected>
                  <Direct />
                </Protected>
              }
            />
            <Route
              path="/direct/:directId"
              element={
                <Protected>
                  <OldURLDirectRedirect />
                </Protected>
              }
            />
            <Route
              path="/history"
              element={
                <Protected>
                  <History />
                </Protected>
              }
            />
            <Route
              path="/liked"
              element={
                <Protected>
                  <LikedVideos />
                </Protected>
              }
            />
            <Route
              path="/mostLiked"
              element={
                <Protected>
                  <MostLikedVideos />
                </Protected>
              }
            />
            <Route
              path="/mostViewed"
              element={
                <Protected>
                  <MostViewedVideos />
                </Protected>
              }
            />
            <Route
              path="/dt"
              element={
                <Protected>
                  <LiveRedirect />
                </Protected>
              }
            />
            <Route
              path="/playlists"
              element={
                <Protected>
                  <Playlists />
                </Protected>
              }
            />
            <Route
              path="/featured"
              element={
                <Protected>
                  <FeaturedPlaylists />
                </Protected>
              }
            />
            <Route
              path="/playlist"
              element={
                <Protected>
                  <Playlist />
                </Protected>
              }
            />
            <Route
              path="/addPlaylist"
              element={
                <Protected>
                  <AddPlaylist />
                </Protected>
              }
            />
            <Route
              path="/editPlaylist/:playlistCode"
              element={
                <Protected>
                  <EditPlaylist />
                </Protected>
              }
            />
            <Route
              path="/editVideo/:videoId"
              element={
                <Protected roles={[UserRole.HYRIS, UserRole.GEEK]}>
                  <EditVideo />
                </Protected>
              }
            />
            <Route
              path="/addVideo"
              element={
                <Protected roles={[UserRole.HYRIS, UserRole.GEEK]}>
                  <AddVideo />
                </Protected>
              }
            />
            <Route
              path="/pending"
              element={
                <Protected roles={[UserRole.HYRIS, UserRole.GEEK]}>
                  <PendingVideos />
                </Protected>
              }
            />
            <Route
              path="/editDirect/:directId"
              element={
                <Protected roles={[UserRole.GEEK]}>
                  <EditDirect />
                </Protected>
              }
            />
            <Route
              path="/addDirect"
              element={
                <Protected roles={[UserRole.GEEK]}>
                  <AddDirect />
                </Protected>
              }
            />
            <Route
              path="/settings"
              element={
                <Protected roles={[UserRole.GEEK]}>
                  <Settings />
                </Protected>
              }
            />
            <Route path="/nqodsivnbqsklmckvpoakbjzn" element={<Limbo special />} />
            <Route path="*" element={<Limbo />} />
          </Routes>
        </Main>
        <Box sx={{ position: "relative", zIndex: "300" }}>
          <Footer />
        </Box>
      </Box>
    </>
  )
}
